export const COMMISSION_SCHEDULE_YEAR_COUNT = 11;

export const getYearKeys = () =>
  Array.from({ length: COMMISSION_SCHEDULE_YEAR_COUNT }, (_, index) => `yr${index + 1}`);

export const getYearLabel = (yearNumber) => {
  if (yearNumber >= COMMISSION_SCHEDULE_YEAR_COUNT) {
    return `Y${COMMISSION_SCHEDULE_YEAR_COUNT}+`;
  }
  return `Y${yearNumber}`;
};

export const getYearColumnDefs = () =>
  getYearKeys().map((key, index) => ({
    key,
    label: getYearLabel(index + 1),
  }));

export const buildEmptyRateObject = (defaultValue = 0) => {
  const rates = {};
  for (const key of getYearKeys()) {
    rates[key] = defaultValue;
  }
  return rates;
};
